import { jsx as _jsx } from "react/jsx-runtime";
export const Upload = ({ data, options }) => {
    return options?.upload ? (options.upload(data)) : (_jsx("a", { href: data.value.url, children: data.value.filename }));
};
